jQuery(document).ready(function () {
    jQuery('.wm-imageCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 3,
            centerMode: true,
            dots: true,
            dotsClass: '',
            appendDots: jQuery(this).siblings().find('.wm-imageCarousel__navigationDots'),
            prevArrow: jQuery(this).siblings().find('.wm-imageCarousel__navigationArrow.-prev'),
            nextArrow: jQuery(this).siblings().find('.wm-imageCarousel__navigationArrow.-next'),
            infinite: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    });
    let $videoCarousel = jQuery('.wm-kayttokohdeVideos__carousel').slick({
        slidesToShow: 1,
        dots: true,
        dotsClass: '',
        appendDots: jQuery('.wm-kayttokohdeVideos__navigationDots'),
        prevArrow: jQuery('.wm-kayttokohdeVideos__navigationArrow.-prev'),
        nextArrow: jQuery('.wm-kayttokohdeVideos__navigationArrow.-next'),
        infinite: true,
        adaptiveHeight: true
    });
    jQuery('.wm-kayttokohdeVideos__thumbnail > a').click(function () {
        jQuery('.wm-kayttokohdeVideos__carousel').slick('slickGoTo', jQuery(this).attr('data-index'));
    });
    centerNavigation();
    $videoCarousel.on('reInit afterChange', centerNavigation);
});
function centerNavigation() {
    let $current = jQuery('.wm-kayttokohdeVideos__navigationDots').find('.slick-active');
    let $dots = jQuery('.wm-kayttokohdeVideos__navigationDots > ul');
    jQuery($dots).css('left', ($current.position().left * -1) + ((jQuery($dots).width() / 2) - ($current.width() / 2)));
}
